var _path, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHalfStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47142 2.82045L9.46361 5.6132C9.67613 6.2114 10.2422 6.61103 10.8771 6.61103H13.0144C13.4942 6.61103 13.6985 7.22119 13.3155 7.51017L11.4817 8.89384C10.9931 9.26253 10.7775 9.89114 10.937 10.4821L11.6943 13.2878C11.8188 13.749 11.2876 14.1054 10.9081 13.8155L8.91054 12.2896C8.37296 11.879 7.62704 11.879 7.08946 12.2896L5.09193 13.8155C4.71236 14.1054 4.18122 13.749 4.30569 13.2878L5.06299 10.4821C5.2225 9.89114 5.00691 9.26253 4.51828 8.89384L2.68445 7.51017C2.30146 7.22119 2.50583 6.61103 2.98561 6.61103H5.12404C5.75897 6.61103 6.32512 6.21128 6.53758 5.61294L7.52909 2.82053C7.68658 2.37698 8.31384 2.37692 8.47142 2.82045Z",
    fill: "#E6E6E6",
    stroke: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_561_2783",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 8,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 16,
    fill: "#FF00FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_561_2783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.05791 2.65323C7.3729 1.76612 8.62742 1.76601 8.94257 2.65306L9.93476 5.44581C10.0764 5.84461 10.4538 6.11103 10.8771 6.11103H13.0144C13.9739 6.11103 14.3827 7.33135 13.6167 7.9093L11.7829 9.29297C11.4571 9.53876 11.3134 9.95783 11.4197 10.3518L12.177 13.1575C12.426 14.0798 11.3637 14.7927 10.6046 14.2128L8.60702 12.687C8.24864 12.4132 7.75136 12.4132 7.39298 12.687L5.39544 14.2128C4.6363 14.7927 3.57403 14.0798 3.82296 13.1575L4.58026 10.3518C4.6866 9.95783 4.54288 9.53876 4.21712 9.29297L2.3833 7.9093C1.61732 7.33135 2.02606 6.11103 2.98561 6.11103H5.12404C5.54733 6.11103 5.92476 5.84453 6.0664 5.44564L7.05791 2.65323Z",
    fill: "#FFBF0B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfStar);
export default __webpack_public_path__ + "static/media/half-star.77affebcb12840e194807d4be3aba2db.svg";
export { ForwardRef as ReactComponent };